import http from './http';
import SearchItem from './models/SearchItem';
import Item from './models/Item';
import PackItem from './models/PackItem';
import ColorItem from './models/ColorItem';
import { getTotalCount, arrayGrouping, sortArray } from 'utils/helpers';

export class ItemsAPI {
	static ITEM_SEARCH_ENDPOINT = 'Item/SearchByItemNumber';
	static ITEM_DETAILS = 'item/getDetails';
	static GET_COLORS = 'item/getColors';

	fetchItems(query) {
		return http
			.get(`${ItemsAPI.ITEM_SEARCH_ENDPOINT}?itemNumber=${query}`)
			.then(items => items.map(item => new SearchItem(item)));
	}

	fetchItemDetailsItem(promotionId, categoryId, itemId, itemNumber) {
		return http
			.get(
				`${ItemsAPI.ITEM_DETAILS}?promotionId=${promotionId}&categoryId=${categoryId}&itemId=${itemId}&itemNumber=${itemNumber}`
			)
			.then(items => items.map(item => new Item(item)));
	}

	fetchItemDetailsPack(promotionId, packId, categoryId) {
		return http
			.get(
				`${ItemsAPI.ITEM_DETAILS}?promotionId=${promotionId}&packId=${packId}&categoryId=${categoryId}`
			)
			.then(items => {
				const packItems = sortArray(items.PackItems, 'Number');

				return {
					packDetails: items.PackDetails.map(item => new Item(item)),
					packItems: {
						items: packItems.map(product => new PackItem(product)),
						totalCount: getTotalCount(packItems, 'QuantityInPack'),
					},
				};
			});
	}

	fetchChooseColors(categoryId, itemId, packId, isPack) {
		const query = isPack
			? `categoryId=${categoryId}&packId=${packId}`
			: `itemId=${itemId}`;

		return http
			.get(`${ItemsAPI.GET_COLORS}?${query}`)
			.then(items =>
				arrayGrouping(items.map(item => new ColorItem(item)), 'id')
			);
	}
}

export default new ItemsAPI();



// WEBPACK FOOTER //
// ./src/api/items.js